import { UserImageSizes } from '../../model/user/imageSizes';

export const imageTypeToImageSize: Record<
  UserImageSizes.Origin | UserImageSizes.Medium | UserImageSizes.Big | UserImageSizes.Small,
  number
> = {
  [UserImageSizes.Origin]: 482, // ToDo: remove and use image size from DB
  [UserImageSizes.Small]: 48,
  [UserImageSizes.Medium]: 180,
  [UserImageSizes.Big]: 480,
};

export const CLIENT_PHOTO_FILE_SIZE_MAX = 8e6;
export const CLIENT_PHOTO_MIN_WIDTH = 480;
export const CLIENT_PHOTO_MIN_HEIGHT = 480;

export enum ClientPhotoSize {
  Small = 180,
  Medium = 480,
}
